import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { BusinessProfile } from 'merchant-components'

export const Route = createFileRoute('/_merchant/_portal/business')({
  component: BusinessProfile,
})
